import React, {useEffect, useState} from "react";
import { Button } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { whatsToHtml } from "../../helpers/Utils";

const CustomPreviewWhatsApp = (props) => {
  const [messages, setMessages] = useState([])
  const [options, setOptions] = useState([])
  const [sheet, setSheet] = useState(false)
  const { L, preview } = props
  const { name, data, handleData, toggle } = preview?? {}

  useEffect(() => {
    // console.log("change preview:", preview)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preview])

  useEffect(() => {
    if (handleData) {
      let msgs = handleData(data)
      if (msgs.length > 1) msgs = msgs.flatMap(msg => [msg, {type: "sent", content: "..."}])
      setMessages(msgs)
    }
    else setMessages(data)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const isImageFile = (url) => {
    if (!url) return false;
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    // Check for image extensions anywhere in the URL path (before query params)
    const urlWithoutQuery = url.split('?')[0].toLowerCase();
    // Check if URL contains any image extension
    const hasImageExtension = imageExtensions.some(ext => urlWithoutQuery.includes('.' + ext));
    // Also check common image CDN patterns (WhatsApp, etc.)
    const isImageCDN = url.includes('whatsapp.net') || url.includes('cdn') || url.includes('image');
    return hasImageExtension || isImageCDN;
  }

  const renderMedia = (media) => {
    if (!media) return null;

    // Always treat URLs as images (since we're only passing image URLs)
    // Only show "view attachment" for non-URL file paths
    const isUrl = media.startsWith('http://') || media.startsWith('https://');
    
    if (isImageFile(media) || isUrl) {
      return (
        <div className="mt-2 mb-2">
          <img 
            src={media} 
            alt="attachment" 
            style={{
              maxWidth: '100%',
              maxHeight: '200px',
              borderRadius: '8px',
              cursor: 'pointer'
            }}
            onClick={() => window.open(media, '_blank', 'noopener,noreferrer')}
          />
        </div>
      );
    } else {
      return (
        <div className="mt-2 mb-2">
          <a 
            href={media} 
            target="_blank"
            rel="noopener noreferrer"
            className="d-inline-flex align-items-center text-primary"
            style={{textDecoration: 'none'}}
          >
            <i className="simple-icon-paper-clip mr-2" style={{fontSize: '1.2rem'}}></i>
            <span>View attachment</span>
          </a>
        </div>
      );
    }
  }

  return (
    <div className="preview-whatsapp">
      <div className="header">{L[name]?? name}</div>
      <div className="iphone">
        <div className="toolbar">
          <div className="user-data">
            <div className="pic">
              <img alt="Profile" src={window.tenant.logo} onError={(e) => { e.target.onerror = null; e.target.src = require("../../assets/img/user.png") }} />
            </div>
            <div className="desc">
              {window.tenant.name}<br/>
              <span>{L["admNotification.online"]}</span>
            </div>
          </div>
        </div>
        <div className="conversation-panel-body">
          {messages && 
            <PerfectScrollbar className="perfect-scrollbar" options={{ suppressScrollX: true, wheelPropagation: false }}>
              {messages.map((m, i) => {
                return (
                  <div key={i} className={`wrap-message-${m.type}`} style={{marginTop: i === 0 ? "8px" : ""}}>
                    {m.media && renderMedia(m.media)}
                    <div className="message fadeIn" dangerouslySetInnerHTML={{ __html:whatsToHtml(m.content)}} ></div>
                    {m.buttons?.length > 0 && 
                      <div className="wrap-buttons" style={{display: (m.buttons.length <= 2 ? "flex" : "block"), marginTop: (m.buttons.length <= 2 ? "4px" : "0")}}>
                        {m.buttons.slice(0, m.buttons.length <= 3 ? m.buttons.length : 2).map((b, i2) => {
                          return <div key={i2} className="button fadeIn" style={{marginTop: (m.buttons.length <= 2 ? "0" : "4px")}}>{b}</div>
                        })}
                        {m.buttons.length > 3 && 
                          <div
                            className="button fadeIn d-flex align-items-center justify-content-center"
                            style={{marginTop: (m.buttons.length <= 2 ? "0" : "4px")}}
                            onClick={() => {setSheet(true); setOptions(m.buttons)}}
                          >
                            <i className="simple-icon-list pr-1"></i>{L["main.seeAllOptions"]}
                          </div>
                        }
                      </div>
                    }
                  </div>
                )
              })}
            </PerfectScrollbar>
          }
        </div>
        {sheet &&
          <div className="fadeIn action-sheet">
            <div className="content">
              <PerfectScrollbar className="perfect-scrollbar" options={{ suppressScrollX: true, wheelPropagation: false }}>
                <div className="title">
                  <div className="btn-close" onClick={() => {setSheet(false)}}>×</div>
                  {L["main.allOptions"]}
                </div>
                {options.map((o, i) => {
                  return <div key={i} className="option" onClick={() => {setSheet(false)}}>{o}</div>
                })}
              </PerfectScrollbar>
            </div>
          </div>
        }
      </div>
      <div className="footer">
        <Button outline color="secondary" size="sm" onClick={() => { toggle() }}>{L["admNotification.closePreview"]}</Button>
      </div>
    </div>
  )
}
export default CustomPreviewWhatsApp